/**************************************************
 * Nombre:       Tarjeta_Indicador
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {theme} from "../../Tema";
import {NEGRITA} from "../../Constantes";
import balanza from '../../Recursos/Iconos/ic_balanza_roja.svg'
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";


const Tarjeta_Indicador = ({item}) => {
    const {sCell, masSM} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                backgroundColor: theme.palette.primary.main,
                color: '#fff',
                p: sCell ? 2 : 3,
                border: 1,
                borderColor: '#ffffff80',

            }}
        >

            <Grid container size={{xs: 3, sm: 3, md: 3}} sx={{justifyContent: 'flex-start'}}>
                <img src={balanza} alt="balanza" width={ sCell ? 25 :40} height={'auto'}/>
            </Grid>


            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 9, sm: 9, md: 9}}>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography
                        sx={{fontFamily: NEGRITA, fontSize: sCell ? 24 : 40, fontWeight: 400, lineHeight: 1.1}}>{`+ ${item.numero}`}</Typography>
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography sx={{fontSize: sCell ? 10 : 16, fontWeight: 400, lineHeight: 1.1}}>{item.nombre}</Typography>
                </Grid>

            </Grid>


        </Grid>
    )

}
export default Tarjeta_Indicador